module.exports = __webpack_public_path__ + "tagesrune_256x256.png?e925df531ce2f5d3d4a7ee6372ce2f11";


//////////////////
// WEBPACK FOOTER
// ./lib/assets/tagesrune_256x256.png
// module id = 78
// module chunks = 0